<template>
  <div class="fp" v-if="list.length">
    <div class="fp-list">
      <div class="fp-list-item" v-for="(item, index) in list">
        <a :href="item.url + '?from=main_' + index" class="fp-item fp-item--2">
          <picture class="fp-item-picture">
            <source :srcset="item.image.webp" type="image/webp">
            <source :srcset="item.image.jpeg" type="image/jpeg">
            <img :src="item.image.jpeg" :alt="item.name" loading="lazy"/>
          </picture>
          <div class="fp-item-content">
            <div class="fp-item-marks" v-if="item.period">
              <div class="fp-item-mark">
                {{ item.period }}
              </div>
            </div>
            <div class="fp-item-title">
              <div class="fp-item-title-content">
                <div class="item" v-html="item.name"></div>
              </div>
            </div>
            <div class="fp-item-text" v-if="item.text">
              <div class="fp-item-text-content">
                {{ item.text }}
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      list: []
    }
  },
  methods: {
    getList() {
      axios.get('/slider/get-catalog-categories').then((response) => {
        this.list = response.data || []
      })
    },
  },
  created() {
    this.getList()
  }
}
</script>